/**
 * Турецкий набор строк.
 */

import type { Strings } from './index';

export const tr: Strings = {
  login_title: 'CargoPASS oturumu açma',
  login_phone_label: 'Telefon numarası',
  login_code_request: 'Kod al',
  login_code_label: 'Mesajdaki kod',
  login_code_submit: 'Giriş yap',
  login_failed: 'Giriş yapılamadı. Lütfen yeniden deneyin.',
  works_title: 'İşler',
  works_more: 'Daha fazla göster',
  works_failed: 'Liste yüklenemedi.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'Telefon ile',
  login_channel_email: 'E-posta ile',
  login_email_label: 'E-posta adresi',
  login_terms_label: 'Kullanım koşullarını kabul ediyorum',
  company_switcher_label: 'Şirket',
  language_label: 'Dil',
  state_loading: 'Yükleniyor…',
  state_empty: 'Henüz bir şey yok',
  state_error: 'Veriler alınamadı',
  state_no_access: 'Bu sayfa size açık değil',
  no_membership_title: 'Hiçbir firmaya bağlı değilsiniz',
  no_membership_explain: 'Çalışmaya başlamak için bir firmaya katılın ya da kendi firmanızı açın.',
  company_create_submit: 'Firma oluştur',
  company_name_label: 'Firma adı',
  company_form_type_label: 'Firma türü',
  company_tax_id_label: 'Kayıt numarası',
  company_legal_address_label: 'Yasal adres',
  company_members_title: 'Firma çalışanları',
  not_found_title: 'Böyle bir sayfa yok',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'Profilim',
  profile_sessions_title: 'Etkin oturumlar',
  profile_session_current: 'Geçerli oturum',
  profile_session_never_used: 'Hiç kullanılmadı',
  profile_session_terminate: 'Sonlandır',
  profile_channel_add: 'İletişim kanalı ekle',
  profile_channel_code_request: 'Kodu gönder',
  profile_channel_confirm: 'Kanalı doğrula',
  members_title: 'Çalışanlar',
  members_invite: 'Çalışan davet et',
  invite_channel_phone: 'Telefonla',
  invite_channel_email: 'E-postayla',
  invite_role_label: 'Rol',
  invite_submit: 'Daveti gönder',
  invitations_title: 'Davetler',
  invitation_revoke: 'Geri al',
  invitation_resend: 'Yeniden gönder',
  rights_title: 'Çalışan hakları',
  rights_grants: 'Rolün üstüne verilen',
  rights_denies: 'Kişisel olarak yasaklanan',
  rights_grant_add: 'Hak ver',
  rights_deny_add: 'Yasak koy',
  rights_remove: 'Kaldır',
  company_profile_title: 'Firma profili',
  company_documents_title: 'Firma belgeleri',
  company_type_transport: 'Taşıyıcı',
  company_type_logistics: 'Lojistik firması',
  member_documents_title: 'Çalışan belgeleri',
  document_download: 'Dosyayı aç',
  enum_unknown: 'Bilinmiyor',
  role_director: 'Direktör',
  role_logist: 'Lojistikçi',
  role_dispatcher: 'Sevkiyatçı',
  role_accountant: 'Muhasebeci',
  role_mechanic: 'Makinist',
  role_driver: 'Sürücü',
  member_status_active: 'Geçerli',
  member_status_closed: 'Kapalı',
  permission_company_staff_manage: 'Çalışanları yönet',
  permission_company_rights_manage: 'Hakları yönet',
  permission_company_fleet_manage: 'Filoyu yönet',
  permission_company_fleet_repair: 'Onarımı işaretle',
  permission_company_docs_manage: 'Belgeleri yönet',
  permission_company_listings_manage: 'İlanları yönet',
  permission_company_cargo_take: 'Yük alma',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Araç ve sürücü atama',
  document_status_pending: 'İncelemede',
  document_status_verified: 'Doğrulandı',
  document_status_rejected: 'Reddedildi',
  document_status_expired: 'Süresi doldu',
  document_status_not_verified: 'Doğrulanmadı',
  invitation_status_pending: 'Yanıt bekliyor',
  invitation_status_accepted: 'Kabul edildi',
  invitation_status_revoked: 'İptal edildi',
  invitation_status_expired: 'Süresi doldu',

  // Блок `WEB-1.3`. До волны 4 — машинный подстрочник (CR-008): присутствие и
  // непустота обязательны, содержимое проверке не подлежит.
  fleet_title: 'Şirket filosu',
  fleet_add: 'Araç ekle',
  fleet_vin: 'VIN numarası',
  fleet_tech_passport: 'Teknik pasaport numarası',
  fleet_kind_label: 'Araç türü',
  fleet_body_type_label: 'Kasa tipi',
  fleet_withdraw: 'Kayıttan çıkar',
  fleet_withdrawn_at: 'Çıkarılma tarihi',
  fleet_empty: 'Kayıt şimdilik boş',
  service_title: 'Araç servisi',
  service_state_label: 'Teknik durum',
  service_state_change: 'Durumu değiştir',
  service_records_title: 'İş günlüğü',
  service_record_add: 'Kayıt ekle',
  service_description: 'İş açıklaması',
  service_parts: 'Değiştirilen parçalar',
  service_cost: 'Gider',
  service_currency: 'Para birimi',
  service_records_empty: 'Henüz kayıt yok',
  vin_claims_title: 'VIN serbest bırakma başvuruları',
  vin_claim_create: 'Başvuru yap',
  vin_claim_object: 'İtiraz et',
  vin_claim_window_ends_at: 'İtiraz penceresi bitişi',
  vin_claims_empty: 'Henüz başvuru yok',
  vehicle_kind_tractor: 'Çekici',
  vehicle_kind_trailer: 'Römork',
  body_type_tarpaulin: 'Tenteli kasa',
  body_type_refrigerator: 'Frigorifik kasa',
  body_type_isothermal: 'İzotermik kasa',
  body_type_box: 'Kapalı kasa',
  body_type_flatbed: 'Açık kasa',
  body_type_platform: 'Platform kasa',
  body_type_lowbed: 'Lowbed kasa',
  body_type_mega: 'Mega kasa',
  body_type_car_carrier: 'Oto taşıyıcı kasa',
  body_type_tipper: 'Damperli kasa',
  body_type_walking_floor: 'Yürüyen tabanlı kasa',
  body_type_tank: 'Tanker kasa',
  body_type_silo: 'Silobas kasa',
  body_type_container_chassis: 'Konteyner şasisi',
  body_type_bdf: 'BDF kasa',
  body_type_timber: 'Tomruk kasası',
  body_type_livestock: 'Canlı hayvan kasası',
  body_type_coil: 'Rulo kasası',
  body_type_heavy_haul: 'Ağır nakliye kasası',
  body_type_extendable: 'Uzayabilir kasa',
  repair_state_fault_detected: 'Arıza tespit edildi',
  repair_state_in_repair: 'Tamirde',
  repair_state_repaired: 'Tamir edildi',
  repair_state_ready: 'Çalışmaya hazır',
  vehicle_status_active: 'Kayıtta',
  vehicle_status_withdrawn: 'Kayıttan çıkarıldı',
  vin_claim_status_pending: 'İtiraz penceresi açık',
  vin_claim_status_objected: 'İtiraz edildi',
  vin_claim_status_awaiting_admin: 'Personel kararı bekleniyor',
  vin_claim_direction_outgoing: 'Bizim başvurumuz',
  vin_claim_direction_incoming: 'Bize gelen başvuru',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Araç transferi takibi',
  tracking_pin_hint: 'Müşterinin bağlantıyla birlikte verdiği altı haneli PIN kodunu girin. PIN olmadan sayfa hiçbir şey göstermez.',
  tracking_pin_label: 'Altı haneli PIN',
  tracking_pin_submit: 'Aç',
  tracking_offline: 'Bağlantı yok. İnterneti kontrol edip tekrar deneyin.',
  tracking_offline_refresh: 'Bağlantı yok — bağlantı geri geldiğinde yenilenecek.',
  tracking_status_changed_at: 'Durum değişti',
  tracking_vehicle: 'Araç',
  tracking_route: 'Güzergâh',
  tracking_distance: 'Mesafe',
  tracking_transit: 'Transit',
  tracking_border_crossings: 'Sınır geçişi sayısı',
  tracking_last_position: 'Son konum',
  tracking_no_position: 'Konum henüz alınmadı',
  tracking_open_map: 'Haritada aç',
  tracking_photos: 'Araç teslim alımı',
  tracking_photo_open: 'Fotoğrafı aç',
  tracking_photo_plate: 'Plaka',
  tracking_photo_close: 'Kapat',
  tracking_milestones: 'Aşamalar',
  tracking_locked_title: 'Bağlantı geçici olarak kullanılamıyor',
  tracking_retry: 'PIN\'i yeniden gir',
  tracking_gone_title: 'Bağlantı artık geçerli değil',
  tracking_map_title: 'Harita: son konum',
  work_status_CREATED: 'Oluşturuldu',
  work_status_ASSIGNED: 'Atandı',
  work_status_ACCEPTED: 'İcraya kabul edildi',
  work_status_AT_PICKUP: 'Yüklemede',
  work_status_AT_HANDOVER: 'Araç teslim alımı',
  work_status_IN_TRANSIT: 'Yolda',
  work_status_DELIVERED: 'Teslim edildi',
  work_status_COMPLETED: 'Tamamlandı',
  work_status_CANCELLED: 'İptal edildi',
  work_status_ARCHIVED: 'Arşivde',
  peregon_vehicle_kind_tractor: 'Çekici',
  peregon_vehicle_kind_tractor_with_trailer: 'Römorklu çekici',
  peregon_vehicle_kind_car: 'Binek otomobil',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  // До волны 4 значения этого языка — подстрочник (CR-008).
  cargo_listings_title: 'Yük ilanları',
  cargo_listings_create: 'İlan oluştur',
  cargo_listings_more: 'Daha fazla göster',
  cargo_listings_empty: 'Henüz ilan yok',
  cargo_listing_edit: 'Düzenle',
  cargo_listing_close: 'Kapat',
  cargo_listing_close_confirm: 'İlan kapatılsın mı? Kapatılan ilan akışa dönmez.',
  cargo_listing_km: 'km',
  cargo_listing_kg: 'kg',
  cargo_listing_days: 'gün',
  cargo_listing_transit: 'Transit',
  cargo_listing_borders: 'Sınır geçişleri',
  cargo_listing_slots_free: 'Boş',
  cargo_listing_slots_of: 'toplam',
  cargo_listing_fixed: 'Sabit fiyat',
  cargo_listing_payment: 'Ödeme',
  cargo_listing_form_title_new: 'Yeni yük ilanı',
  cargo_listing_form_title_edit: 'Yük ilanını düzenle',
  cargo_listing_form_origin: 'Yükleme şehri',
  cargo_listing_form_destination: 'Boşaltma şehri',
  cargo_listing_form_city_search: 'Şehir adını yazmaya başlayın',
  cargo_listing_form_loading_at: 'Yükleme tarihi',
  cargo_listing_form_unload_by: 'Son boşaltma tarihi',
  cargo_listing_form_vehicles_count: 'Gereken araç sayısı',
  cargo_listing_form_cargo_type: 'Yük',
  cargo_listing_form_weight: 'Araç başına ağırlık, kg',
  cargo_listing_form_adr: 'Tehlikeli yük (ADR)',
  cargo_listing_form_body_type: 'Kasa tipi',
  cargo_listing_form_body_subtype: 'Kasa alt tipi',
  cargo_listing_form_temperature_from: 'en az',
  cargo_listing_form_temperature_to: 'en çok',
  cargo_listing_form_price: 'Araç başına fiyat',
  cargo_listing_form_currency: 'Para birimi',
  cargo_listing_form_negotiable: 'Pazarlık olur',
  cargo_listing_form_payment_method: 'Ödeme şekli',
  cargo_listing_form_payment_moment: 'Ödeme zamanı',
  cargo_listing_form_deferral_days: 'Vade günü',
  cargo_listing_form_comment: 'Yorum',
  cargo_listing_form_submit: 'Yayınla',
  cargo_listing_form_save: 'Değişiklikleri kaydet',
  cargo_offers_title: 'Taşıyıcı teklifleri',
  cargo_offer_accept: 'Onayla',
  cargo_offer_decline: 'Reddet',
  cargo_offer_decline_confirm: 'Teklif reddedilsin mi? Taşıyıcı reddi görecek.',
  cargo_offer_agrees: 'Koşullarınızı kabul ediyor',
  cargo_offer_counter: 'Kendi fiyatını öneriyor',
  cargo_offer_documents_verified: 'Belgeleri doğrulandı',
  cargo_offer_vehicles: 'Araç',
  cargo_offer_price: 'Taşıyıcı fiyatı',
  cargo_offer_listing_price: 'İlan fiyatı',
  cargo_offer_expires: 'Yanıt süresi',
  cargo_offer_more: 'Daha fazla teklif',
  cargo_slots_title: 'Sipariş panosu',
  cargo_slot_work: 'İş',
  listing_status_OPEN: 'Açık',
  listing_status_TAKEN: 'Tüm araçlar bulundu',
  listing_status_CLOSED: 'Kapalı',
  listing_status_CANCELLED: 'İptal edildi',
  listing_status_PENDING_REVIEW: 'İncelemede',
  listing_status_REJECTED: 'Reddedildi',
  cargo_offer_status_PENDING: 'Karar bekleniyor',
  cargo_offer_status_APPROVED: 'Onaylandı — taşıyıcı onayı bekleniyor',
  cargo_offer_status_CONFIRMED: 'Taşıyıcı onayladı',
  cargo_offer_status_REJECTED: 'Reddedildi',
  cargo_offer_status_WITHDRAWN: 'Taşıyıcı geri çekti',
  cargo_offer_status_EXPIRED: 'Süresi doldu',
  cargo_offer_status_SUPERSEDED: 'Boş araç kalmadı',
  cargo_slot_status_OPEN: 'Boş',
  cargo_slot_status_RESERVED: 'Taşıyıcı onayı bekleniyor',
  cargo_slot_status_TAKEN: 'Dolu',
  cargo_slot_status_CANCELLED: 'İptal edildi',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (som)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Nakit',
  payment_method_bank_transfer: 'Banka havalesi',
  payment_moment_prepayment: 'Peşin',
  payment_moment_on_unloading: 'Boşaltmada',
  payment_moment_deferred: 'Vadeli',
  loading_type_rear: 'Arkadan',
  loading_type_side: 'Yandan',
  loading_type_top: 'Üstten',
  loading_type_full_uncover: 'Tam açık',
  body_parameter_length_m: 'Uzunluk, m',
  body_parameter_width_m: 'Genişlik, m',
  body_parameter_height_m: 'Yükseklik, m',
  body_parameter_volume_m3: 'Hacim, m³',
  body_parameter_capacity_t: 'Taşıma kapasitesi, t',
  body_parameter_loading_type: 'Yükleme tipi',
  body_parameter_temperature: 'Sıcaklık, °C',
  body_parameter_cars_capacity: 'Araç kapasitesi',
};
